import { createFileRoute } from "@tanstack/react-router";

import useDeflowSessionStore, {
  DeflowSessionStates,
} from "@/stores/useDeflowSessionStore";
import usePluginShellState from "@/stores/usePluginShellState";
import { Plugin } from "@/components/plugin-shared/plugin-shell";
import { CenteredLoader } from "@/components/plugin-shared/centered-loader";
import { Centered } from "@/components/plugin-shared/centered";

export const Route = createFileRoute("/plugin/figma/")({
  component: PluginPage,
});

function PluginPage() {
  const { status } = usePluginShellState();
  const { sessionState } = useDeflowSessionStore();

  return (
    <main className="h-[700px] overflow-clip">
      {status === "ready" &&
        sessionState === DeflowSessionStates.Authenticated && <Plugin />}
      {status !== "failed" &&
        sessionState !== DeflowSessionStates.Authenticated && (
          <CenteredLoader />
        )}
      {status === "failed" && (
        <Centered>
          <div className="px-8">
            <p>
              This plugin only works when installed in Figma. Head over to
              Figma Community and install the Deflow plugin.
            </p>
          </div>
        </Centered>
      )}
    </main>
  );
}
